import React from "react";

const AddTowerSuccess = ({ onCancel }) => {
  return (
    <div className="basic-modal">
      <div className="basic-modal__header">
        <h3>Tower Added Successfully</h3>
      </div>
      <div className="basic-modal__body">
        <div className="">
          The tower will only be visible on the table once it has been linked to
          a meter.
        </div>
        <div className="basic-modal__footer">
          <button onClick={onCancel} className="button button--primary">
            Okay
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddTowerSuccess;
